import dayjs from "dayjs";
import { BaseAction } from "../../../../core/actions/BaseAction";
import { IUserResponse } from "../../../../Orchestrator/Types/Index";
import { CountryCodesType } from "../../../../Orchestrator/Types/Types/Country/CountryCodesType";

interface InitializeFormParams {
    form: any;
    userData: IUserResponse;
    countryCodeData: CountryCodesType[];
}

export class InitializeFormAction extends BaseAction<void, InitializeFormParams> {
    override async run(): Promise<void> {
        try {
            const { form, userData, countryCodeData } = this.params!;

            if (userData) {
                const phoneNumberStr = userData.phoneNumber || "";
                let mobileCode = "";
                let phoneNumber = "";

                if (phoneNumberStr.startsWith("+")) {
                    const numberWithoutPlus = phoneNumberStr.substring(1);
                    const matchingCountry = countryCodeData.find((country) =>
                        numberWithoutPlus.startsWith(country.countryCallingCode)
                    );

                    if (matchingCountry) {
                        mobileCode = matchingCountry.countryCallingCode;
                        phoneNumber = numberWithoutPlus.substring(mobileCode.length);
                    }
                }

                if (!mobileCode) {
                    mobileCode = "971";
                    const uaeCountry = countryCodeData.find((country) => country.countryCode === "AE");
                    if (uaeCountry) {
                        form.setFieldValue("phoneCountryCode", uaeCountry.countryCode);
                    }
                }

                form.setFieldsValue({
                    // "PhD" was removed from HonorificEnum (wrong as a title — it's a
                    // degree); profiles saved with it fall back to "Dr" so the select
                    // never shows a raw unmatched "PhD" value.
                    title: userData.title === "PhD" ? "Dr" : userData.title,
                    firstName: userData.firstName,
                    lastName: userData.lastName,
                    email: userData.email,
                    countryCode: userData.countryCode || "AE",
                    phoneNumber: phoneNumber,
                    phoneCountryCode: userData.countryCode || "AE",
                    birthdate: userData.birthdate ? dayjs(userData.birthdate, "YYYY-MM-DD") : undefined,
                    mobileCode: mobileCode || "971",
                    gender: userData.gender,
                });
            }
        } catch (error) {
            console.error("Error initializing form:", error);
        }
    }
}

export const initializeFormAction = new InitializeFormAction();